module.exports = new __parcel__URL__("marine4.c0e83b1b.jpg").toString();